// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right___v9ZK","select":"Header_select__2smhs","clinic":"Header_clinic__vU_eb"};